import React from "react";

import { Flex } from "antd";
import i18next from "i18next";
import styled from "styled-components";

import { BSCoreServicesDtoMarketplaceOrderTotalDto } from "api/reactQuery/querySchemas";
import { formatCurrency } from "components/Utils/agGrid/valueFormatters";
const StyledCardContainer = styled.div<{
  $error?: boolean;
  $isBlueCard?: boolean;
}>`
  width: 19.5%;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 4px 12px;
  background: ${(props) =>
    props.$error ? "#FED9D9" : props.$isBlueCard ? "#F1F7FF" : "#F9F9F9"};
  border-radius: 4px;
  box-shadow: 0 4px 4px 0 #0000000f;
  pointer-events: none;
  text-align: end;
`;
const StyledCardTitle = styled.h4`
  font-size: 11px;
  line-height: 14px;
  font-weight: 400;
  color: #6d6d6d;
`;
const StyledCardValue = styled.span<{
  $hasValue?: boolean;
  $hasError?: boolean;
}>`
  font-size: 14px;
  font-weight: 800;
  line-height: 20px;
  color: ${(props) =>
    props.$hasValue ? (props.$hasError ? "#D21919" : "#181818") : "#b3b3b3"};
`;

export const TTL_WEIGHT_LIMIT = 24200;
export const TTL_TRUCK_AREA_FACTOR_LIMIT = 1;

const SmallCard: React.FC<{
  title: string;
  value: number;
  hasError?: boolean;
  isBlueCard?: boolean;
}> = ({ title, value, hasError, isBlueCard }) => (
  <StyledCardContainer $error={hasError} $isBlueCard={isBlueCard}>
    <StyledCardTitle>{title}</StyledCardTitle>
    <StyledCardValue $hasValue={!!value} $hasError={hasError}>
      {formatCurrency(value, 2, 4)}
    </StyledCardValue>
  </StyledCardContainer>
);

const OrderTotals: React.FC<{
  totals: BSCoreServicesDtoMarketplaceOrderTotalDto;
  isTruckAreaFactorInLimit?: boolean;
  isTotalWeightInLimit?: boolean;
}> = ({ totals, isTruckAreaFactorInLimit, isTotalWeightInLimit }) => {
  return (
    <Flex
      vertical
      style={{ marginLeft: -16, marginRight: -16, width: "calc(100% + 32px)" }}
    >
      <Flex style={{ width: "100%" }} justify="space-between">
        <SmallCard
          title={i18next.t("ttl_truck_area_factor")}
          hasError={
            isTruckAreaFactorInLimit === undefined
              ? false
              : !isTruckAreaFactorInLimit
          }
          value={totals.ttlTruckAreaFactor}
          isBlueCard
        />
        <SmallCard title={i18next.t("ttl_pallets")} value={totals.ttlPallets} />
        <SmallCard
          title={i18next.t("ttl_pallet_count_industrial")}
          value={totals.ttlPalletCountBasketAndIndustrialType}
        />
        <SmallCard
          title={i18next.t("ttl_pallet_count_licensed“")}
          value={totals.ttlPalletCountLicensedType}
        />
        <SmallCard
          title={i18next.t("ttl_weight_limit")}
          hasError={
            isTotalWeightInLimit === undefined ? false : !isTotalWeightInLimit
          }
          value={totals.ttlWeight}
          isBlueCard
        />
      </Flex>
      <Flex style={{ marginTop: 8, width: "100%" }} justify="space-between">
        <SmallCard
          title={i18next.t("ttl_volume_in_hl")}
          value={totals.ttlVolumeInHL}
        />
        <SmallCard
          title={i18next.t("ttl_beer_cost_wt_vat_in_bgn")}
          value={totals.ttlBeerCostWithoutVAT}
          isBlueCard
        />
        <SmallCard
          title={i18next.t("ttl_beer_cost_w_vat_in_bgn")}
          value={totals.ttlBeerCostWithVAT}
        />
        <SmallCard
          title={i18next.t("ttl_packaging_cost_in_bgn")}
          value={totals.ttlPackagingCost}
        />
        <SmallCard
          title={i18next.t("ttl_beer_w_vat_packaging_cost_in_bgn")}
          value={totals.ttlBeerWithVATAndPackagingCost}
        />
      </Flex>
    </Flex>
  );
};
export default OrderTotals;
